var map = {
	"./bienvenida.svg": "2c5f",
	"./isotipo-aliaddo.svg": "5274",
	"./login-erp.svg": "1b5c",
	"./logo-aliaddo.svg": "b056",
	"./misc-app/building.svg": "8574",
	"./misc-app/certification.svg": "fb42",
	"./misc-app/empty.svg": "f594",
	"./misc-app/file-certificate.svg": "574f",
	"./misc-app/payments.svg": "dd6b",
	"./misc-app/request-accept.svg": "157a",
	"./misc-app/time.svg": "8c47",
	"./misc-app/time2.svg": "f6bc",
	"./register_banner_companies.svg": "99dc",
	"./register_banner_students.svg": "f67c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f350";